import React from "react";
import styles from "./BottomBar.module.less";
import { Link } from "react-router-dom";

export default function BottomBar(props: { className?: string; onMenuOpen: () => void; onMenuClose: () => void }) {
    return (
        <nav className={[styles.BottomBar, props.className].join(" ")}>
            <ul className={styles["BottomBar-ul"]}>
                <li className={styles["BottomBar-li"]}>
                    <a
                        href="/"
                        className={styles["BottomBar-link"]}
                        onClick={e => {
                            e.preventDefault();
                            props.onMenuOpen();
                        }}
                    >
                        Menu
                    </a>
                </li>
                <li className={styles["BottomBar-li"]}>
                    <Link to="/contact" onClick={props.onMenuClose} className={styles["BottomBar-link"]}>Contact</Link>
                </li>
                <li className={styles["BottomBar-li"]}>
                    <Link to="/speak-up" onClick={props.onMenuClose} className={styles["BottomBar-link"]}>Speak up</Link>
                </li>
            </ul>
        </nav>
    );
}
